module.exports = __webpack_public_path__ + "public/images/program/program-4.866c1a58e72e62c37368b08ccdfc7d52.png";